import { createAction } from "redux-actions";
import { moduleSlug } from "modules/PrimaryKey/constants";

export const clearConfigs = createAction(`${moduleSlug}/CLEAR_CONFIGS`);

export const getConfigs = createAction(`${moduleSlug}/GET_CONFIGS`);
export const getConfigsSuccess = createAction(`${moduleSlug}/GET_CONFIGS/SUCCESS`);
export const getConfigsError = createAction(`${moduleSlug}/GET_CONFIGS/ERROR`);

export const getConfig = createAction(`${moduleSlug}/GET_CONFIG`);
export const getConfigSuccess = createAction(`${moduleSlug}/GET_CONFIG/SUCCESS`);
export const getConfigError = createAction(`${moduleSlug}/GET_CONFIG/ERROR`);

export const getConfigExamples = createAction(`${moduleSlug}/GET_CONFIG_EXAMPLES`);
export const getConfigExamplesSuccess = createAction(`${moduleSlug}/GET_CONFIG_EXAMPLES/SUCCESS`);

export const setConfigFormDialog = createAction(`${moduleSlug}/SET_CONFIG_FORM_DIALOG`);
export const mergeConfigFormDialog = createAction(`${moduleSlug}/MERGE_CONFIG_FORM_DIALOG`);

export const createConfig = createAction(`${moduleSlug}/CREATE_CONFIG`);

export const editConfig = createAction(`${moduleSlug}/EDIT_CONFIG`);

export const validateConfig = createAction(`${moduleSlug}/VALIDATE_CONFIG`);

export const extractKey = createAction(`${moduleSlug}/EXTRACT_KEY`);
export const extractKeySuccess = createAction(`${moduleSlug}/EXTRACT_KEY/SUCCESS`);
export const setExtractKeyDialog = createAction(`${moduleSlug}/SET_EXTRACT_KEY_DIALOG`);
